import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  base: process.env.BASE_URL,
  mode: 'history',
  routes: [
    {
      path: '/',
      alias: '/start',
      name: 'start',
      component: () => import('@/views/start/start.vue')
    },
    {
      path: '/draw',
      name: 'draw',
      component: () => import('@/views/draw/draw.vue')
    },
    {
      path: '/drawing-ready',
      name: 'drawing-ready',
      component: () => import('@/views/drawing-ready/drawing-ready.vue')
    },
    {
      path: '/invent',
      name: 'invent',
      component: () => import('@/views/invent/invent.vue')
    },
    {
      path: '/invention-ready',
      name: 'invention-ready',
      component: () => import('@/views/invention-ready/invention-ready.vue')
    },
    {
      path: '/share',
      name: 'share',
      component: () => import('@/views/share/share.vue')
    },
    {
      path: '/share/link',
      name: 'share-link',
      component: () => import('@/views/share-link/share-link.vue')
    },
    {
      path: '/share/sms',
      name: 'share-sms',
      component: () => import('@/views/share-sms/share-sms.vue')
    },
    {
      path: '/share/email',
      name: 'share-email',
      component: () => import('@/views/share-email/share-email.vue')
    },
    {
      path: '/souvenir/:folder_id/inventions/:image_id',
      name: 'souvenir',
      component: () => import('@/views/souvenir/souvenir.vue')
    },
    {
      path: '/settings',
      name: 'settings',
      component: () => import('@/views/settings/settings.vue')
    },
    {
      path: '/elements',
      name: 'elements',
      component: () => import('@/views/elements/elements.vue')
    },
    {
      path: '/test-touch',
      name: 'test-touch',
      component: () => import('@/views/test-touch/test-touch.vue')
    },
    {
      path: '*',
      name: '404',
      component: () => import('@/views/page-not-found/page-not-found.vue')
    }
  ]
});
